(() => {
  'use strict';
  const settings = window.FlyWellTheme || {};
  const root = settings.root || window.Shopify?.routes?.root || '/';
  const handles = ['flywell', 'fly-well-hoodie', 'hoodie-flywell-pouch', 'hoodie-2-flywell-pouches'];
  const productRequests = new Map();
  const approvedPassionVariants = new Set(['45549172883762', '45549172916530', '45549172949298']);
  function cartItemImage(item) {
    if (approvedPassionVariants.has(String(item.variant_id || item.id))) return "//drinkflywell.com/cdn/shop/t/51/assets/fw-approved-passion-pouch.png?v=32630701197148455801793754771";
    return item.image || item.featured_image?.url || '';
  }

  const discountKey = 'fw-shopify-discount';
  const codes = new Set(['TRAVEL25', 'JAPAN25', 'ITALY25', 'GREECE25', 'PORTUGAL25', 'AUSTRALIA25', 'KENYA25', 'BRAZIL25', 'MOROCCO25']);
  const monthlyPlan = '4046455090';
  let currentCart = null;
  let returnFocus = null;
  let cartRequest = Promise.resolve();
  let discountRequest = Promise.resolve();
  let cartRenderVersion = 0;
  const url = path => root + path.replace(/^\//, '');
  const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[char]));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:currentCart?.currency || settings.currency || window.Shopify?.currency?.active || 'USD'}).format(Number(cents) / 100);
  async function request(path, data) {
    const response = await fetch(url(path), {credentials:'same-origin', headers:{Accept:'application/json', ...(data ? {'Content-Type':'application/json'} : {})}, ...(data ? {method:'POST', body:JSON.stringify(data)} : {})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Please try again.');
    return result;
  }
  function product(handle) {
    if (!productRequests.has(handle)) productRequests.set(handle, request('products/' + encodeURIComponent(handle) + '.js').catch(error => {productRequests.delete(handle); throw error;}));
    return productRequests.get(handle);
  }
  async function products() {
    const values = await Promise.all(handles.map(product));
    return Object.fromEntries(values.map(value => [value.handle, value]));
  }
  function currentDiscount() {
    try { const code = localStorage.getItem(discountKey) || localStorage.getItem('fw-passport-code'); return codes.has(code) ? code : ''; } catch { return ''; }
  }
  function cartDiscountApplications(value) {
    return [...(value?.cart_level_discount_applications || []), ...(value?.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application).filter(Boolean))];
  }
  function hasOtherDiscount(value) {
    const applications = cartDiscountApplications(value);
    if (applications.some(application => application.type !== 'discount_code' || !codes.has(String(application.title || '').toUpperCase()))) return true;
    if ((value?.discount_codes || []).some(entry => !codes.has(String(entry.code || '').toUpperCase()))) return true;
    return Number(value?.total_discount) > 0 && !applications.length;
  }
  function hasDiscountLink(href) {
    try {
      const target = new URL(href, location.href);
      return /\/(?:discount|discounts)\//.test(target.pathname) || target.searchParams.has('discount') || target.searchParams.has('discount_code');
    } catch { return false; }
  }
  function hasOtherDiscountHint() {
    try {
      const params = new URLSearchParams(location.search || '');
      const explicit = params.get('discount') || params.get('discount_code');
      if (explicit && !codes.has(explicit.toUpperCase())) return true;
      const cookie = (document.cookie || '').split(';').map(value => value.trim()).find(value => value.startsWith('discount_code='));
      const cookieCode = cookie ? decodeURIComponent(cookie.slice('discount_code='.length)) : '';
      return !!cookieCode && !codes.has(cookieCode.toUpperCase());
    } catch { return true; }
  }
  function setDiscount(value) {
    const code = String(value || '').trim().toUpperCase();
    if (!codes.has(code)) return Promise.resolve(false);
    try {localStorage.setItem(discountKey, code);} catch {}
    document.querySelectorAll('[data-fw-checkout]').forEach(link => {link.href = checkoutUrl();});
    discountRequest = discountRequest.catch(() => false).then(async () => {
      try {
        const value = await cart();
        if (hasOtherDiscount(value) || hasOtherDiscountHint()) return false;
        currentCart = await request('cart/update.js', {discount:code});
        badge(currentCart);
        document.dispatchEvent(new CustomEvent('cart:updated', {detail:currentCart}));
        return true;
      } catch { return false; }
    });
    return discountRequest;
  }
  function checkoutUrl() {
    return url('checkout');
  }
  function badge(cart) {
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    let bubble = icon.querySelector('.cart-count-bubble');
    if (!bubble && cart.item_count) {bubble = document.createElement('div'); bubble.className = 'cart-count-bubble'; icon.append(bubble);}
    if (bubble) {bubble.hidden = !cart.item_count; bubble.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + ' items</span>';}
  }
  async function cart() {
    const value = await request('cart.js');
    currentCart = value; badge(value);
    return value;
  }
  async function add(id, quantity = 1, sellingPlan = null, properties = null) {
    await discountRequest.catch(() => false);
    const item = {id:String(id), quantity:Number(quantity)};
    if (!/^\d+$/.test(item.id) || !Number.isInteger(item.quantity) || item.quantity < 1) throw new Error('Please choose an available product option.');
    if (sellingPlan) item.selling_plan = String(sellingPlan);
    if (properties && Object.keys(properties).length) item.properties = properties;
    const result = await request('cart/add.js', {items:[item]});
    const updated = await cart();
    document.dispatchEvent(new CustomEvent('cart:updated', {detail:updated}));
    return result.items?.[0] || result;
  }
  function resolveBundle(bundle, hoodie, tonic) {
    return bundle.variants.find(variant => variant.option1 === hoodie.option1 && variant.option2 === hoodie.option2 && variant.option3 === tonic.option1);
  }
  async function addBundle(hoodieId, tonicId, count) {
    count = Number(count);
    if (![0, 1, 2].includes(count)) throw new Error('Choose a bundle first.');
    if (!count) return add(hoodieId, 1);
    const [hoodies, tonic, bundle] = await Promise.all([product('fly-well-hoodie'), product('flywell'), product(count === 1 ? 'hoodie-flywell-pouch' : 'hoodie-2-flywell-pouches')]);
    const hoodie = hoodies.variants.find(variant => String(variant.id) === String(hoodieId));
    const pouch = tonic.variants.find(variant => String(variant.id) === String(tonicId));
    if (!hoodie || !pouch || pouch.option2 !== '15') throw new Error('Choose your hoodie and pouch options.');
    const variant = resolveBundle(bundle, hoodie, pouch);
    if (!variant?.available) throw new Error('This bundle combination is currently sold out.');
    return add(variant.id, 1);
  }
  function toast(message) {
    let element = document.querySelector('.prototype-toast');
    if (!element) {element = document.createElement('div'); element.className = 'prototype-toast'; element.setAttribute('role','status'); document.body.append(element);}
    element.textContent = message; element.hidden = false;
    clearTimeout(element._timer); element._timer = setTimeout(() => {element.hidden = true;}, 4500);
  }
  function closeDrawer() {
    document.getElementById('prototype-modal')?.remove(); document.body.style.overflow = '';
    returnFocus?.focus();
  }
  function lineDescription(item) {
    const plan = item.selling_plan_allocation?.selling_plan?.name;
    return '<p>' + esc(item.variant_title || '') + '</p>' + (plan ? '<small>' + esc(plan) + '</small>' : '');
  }
  function element(tag, className, parent, attribute) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (attribute) node.setAttribute(attribute, '');
    parent.append(node);
    return node;
  }
  async function cartProduct(item) {
    const handle = item.handle || (item.url || '').match(/\/products\/([^/?#]+)/)?.[1];
    if (!handle) return null;
    try {return await product(decodeURIComponent(handle));} catch {return null;}
  }
  function updateHextomCartHook(hook, item, catalogProduct) {
    const handle = catalogProduct?.handle || item.handle || (item.url || '').match(/\/products\/([^/?#]+)/)?.[1] || '';
    // Match hextom_usb_cart.liquid: escape each tag before reversing its characters.
    const tags = (catalogProduct?.tags || []).map(tag => Array.from(esc(tag)).reverse().join('')).join(',');
    const data = { 'data-v1': catalogProduct?.id || item.product_id || '', 'data-v2': handle, 'data-v3': catalogProduct?.type || item.product_type || '', 'data-v4': tags };
    Object.entries(data).forEach(([name, value]) => {if (hook.getAttribute(name) !== String(value)) hook.setAttribute(name, String(value));});
  }
  function renderCartLines(content, value, catalogProducts) {
    let lines = content.querySelector('[data-fw-cart-lines]');
    if (!lines) {
      content.innerHTML = '';
      const header = element('div', 'prototype-cart-head', content, 'data-fw-cart-head');
      header.innerHTML = '<span>PRODUCT</span><span>QUANTITY</span><span>TOTAL</span>';
      lines = element('div', '', content, 'data-fw-cart-lines');
      lines.style.display = 'flex'; lines.style.flexDirection = 'column';
      element('p', '', content, 'data-fw-cart-empty').textContent = 'Your cart is empty.';
    }
    content.querySelector('[data-fw-cart-head]').style.display = value.items.length ? '' : 'none';
    content.querySelector('[data-fw-cart-empty]').hidden = !!value.items.length;
    const existing = new Map([...lines.querySelectorAll('[data-fw-line-key]')].map(node => [node.getAttribute('data-fw-line-key'), node]));
    value.items.forEach((item, index) => {
      let line = existing.get(item.key);
      if (!line) {
        line = element('div', 'prototype-cart-line', lines, 'data-fw-line-key');
        line.setAttribute('data-fw-line-key', item.key);
        const row = element('div', 'prototype-cart-row', line);
        element('a', '', row, 'data-fw-line-image');
        const details = element('div', '', row);
        element('div', '', details, 'data-fw-line-details');
        element('span', 'htusb-ui-boost htusb-ui-cart-boost htusb-data', details, 'data-fw-hextom-cart');
        const input = element('input', '', line, 'data-fw-quantity');
        input.type = 'number'; input.min = '0'; input.step = '1';
        element('span', '', line, 'data-fw-line-total');
      }
      existing.delete(item.key);
      // CSS order avoids disconnecting hydrated app nodes when Shopify reorders lines.
      line.style.order = String(index);
      const image = line.querySelector('[data-fw-line-image]');
      image.href = item.url;
      image.innerHTML = '<img width="64" height="78" src="' + esc(cartItemImage(item)) + '" alt="' + esc(item.product_title) + '">';
      line.querySelector('[data-fw-line-details]').innerHTML = '<a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a><p>' + money(item.final_price) + '</p>' + lineDescription(item) + '<button class="prototype-remove" data-fw-remove="' + esc(item.key) + '">Remove</button>';
      const input = line.querySelector('[data-fw-quantity]');
      input.setAttribute('data-fw-quantity', item.key);
      input.setAttribute('aria-label', 'Quantity for ' + item.product_title + ' ' + (item.variant_title || ''));
      input.value = item.quantity;
      line.querySelector('[data-fw-line-total]').textContent = money(item.final_line_price);
      updateHextomCartHook(line.querySelector('[data-fw-hextom-cart]'), item, catalogProducts[index]);
    });
    existing.forEach(line => line.remove());
  }
  async function drawer() {
    const value = await cart(); closeDrawer(); returnFocus = document.activeElement;
    const panel = document.createElement('div'); panel.id = 'prototype-modal';
    panel.innerHTML = '<div class="prototype-backdrop" data-fw-close></div><section role="dialog" aria-modal="true" aria-label="Your cart" class="prototype-dialog"><button class="prototype-close" data-fw-close aria-label="Close">×</button><h2>Your cart</h2>' + (value.items.length ? value.items.map(item => '<div class="prototype-cart-row"><img width="64" height="78" src="' + esc(cartItemImage(item)) + '" alt="' + esc(item.product_title) + '"><div><strong>' + esc(item.product_title) + '</strong>' + lineDescription(item) + '<p>' + item.quantity + ' × ' + money(item.final_price) + '</p></div></div>').join('') + '<div class="prototype-total"><strong>Subtotal</strong><strong>' + money(value.total_price) + '</strong></div><p>Shipping, taxes and discounts calculated at checkout.</p><a class="prototype-button" href="' + url('cart') + '">View cart</a><a class="prototype-button secondary" data-fw-checkout href="' + checkoutUrl() + '">Check out</a>' : '<p>Your cart is empty.</p><a class="prototype-button" href="' + url('products/flywell') + '">Continue shopping</a>') + '</section>';
    const travelFaq = document.getElementById('fw-cart-travel-faq-template');
    const title = panel.querySelector('.prototype-dialog > h2');
    if (title && travelFaq instanceof HTMLTemplateElement) title.after(travelFaq.content.cloneNode(true));
    document.body.append(panel); document.body.style.overflow = 'hidden'; panel.querySelector('button').focus();
  }
  async function renderCart(value) {
    const version = ++cartRenderVersion;
    const main = document.getElementById('MainContent'); if (!main) return;
    value = value || await cart();
    const catalogProducts = await Promise.all(value.items.map(cartProduct));
    if (version !== cartRenderVersion) return;
    const page = main.querySelector('[data-fw-cart-page]');
    const content = page?.querySelector('[data-fw-cart-content]');
    const summary = page?.querySelector('.prototype-cart-summary');
    const totals = summary?.querySelector('[data-fw-cart-totals]');
    const checkout = summary?.querySelector('[data-fw-checkout]');
    if (!content || !summary || !totals || !checkout) throw new Error('Your cart could not load. Please refresh to try again.');
    let integrations = summary.querySelector('[data-fw-cart-integrations]');
    if (!integrations) {
      integrations = document.createElement('div');
      integrations.className = 'fw-cart-integrations';
      integrations.setAttribute('data-fw-cart-integrations', '');
      const marker = document.createElement('i');
      marker.setAttribute('data-govx-id', '');
      integrations.append(marker);
      checkout.after(integrations);
    }
    // Keep app mounts continuously connected: removing/reinserting a live iframe resets it.
    renderCartLines(content, value, catalogProducts);
    page.classList.toggle('fw-cart-is-empty', !value.items.length);
    totals.innerHTML = '<div class="prototype-total"><h2>Subtotal</h2><strong>' + money(value.total_price) + '</strong></div><p>Shipping, taxes and discounts calculated at checkout.</p>';
    summary.hidden = !value.items.length;
    integrations.hidden = !value.items.length;
    // App-provided checkout destinations may contain verification/discount state.
    if (checkout.getAttribute('href') === '/checkout') checkout.href = checkoutUrl();
  }
  function quickSelection(form, tonic) {
    const variant = tonic.variants.find(item => item.option1 === form.dataset.cartQuickAdd && item.option2 === form.querySelector('[data-quick-count]').value);
    if (!variant) throw new Error('This quantity is unavailable.');
    const subscription = form.querySelector('[data-quick-subscription]').checked;
    const allocation = subscription ? variant.selling_plan_allocations?.find(item => String(item.selling_plan_id) === monthlyPlan) : null;
    if (subscription && !allocation) throw new Error('Subscription is unavailable for this quantity.');
    return {variant, allocation, plan:allocation?.selling_plan_id || null, price:allocation?.price ?? variant.price};
  }
  function updateQuick(form, tonic) {
    const selected = quickSelection(form, tonic);
    form.elements.id.value = String(selected.variant.id); form.elements.selling_plan.value = selected.plan || '';
    form.querySelector('[data-quick-price]').textContent = money(selected.price);
    form.querySelector('[data-quick-button-price]').textContent = money(selected.price);
    const compare = form.querySelector('[data-quick-compare]'); compare.textContent = money(selected.variant.price); compare.hidden = !selected.allocation;
    form.querySelector('[data-quick-delivery]').textContent = selected.allocation ? 'Delivers once per month · Cancel or pause anytime' : 'One-time purchase · No subscription';
    form.querySelector('[type=submit]').disabled = !selected.variant.available;
    form.querySelector('[data-quick-add-label]').textContent = selected.variant.available ? 'Add to cart' : 'Out of Stock';
    return selected;
  }
  async function initQuickAdd() {
    const forms = [...document.querySelectorAll('[data-cart-quick-add]')]; if (!forms.length) return;
    try {
      const tonic = await product('flywell');
      forms.forEach(form => {
        const refresh = () => {try {updateQuick(form, tonic); form.querySelector('[data-quick-status]').textContent = '';} catch(error) {form.querySelector('[type=submit]').disabled = true; form.querySelector('[data-quick-status]').textContent = error.message;}};
        form.addEventListener('change', refresh); refresh();
      });
    } catch(error) {forms.forEach(form => {form.querySelector('[type=submit]').disabled = true; form.querySelector('[data-quick-status]').textContent = 'Options could not load. Please refresh to try again.';});}
  }
  function customProductSelection(form, tonic) {
    const flavor = form.querySelector('[name=flavor]:checked')?.value;
    const count = form.querySelector('[name=packet-count]:checked')?.value;
    const delivery = form.querySelector('[name=delivery]:checked');
    const variant = tonic.variants.find(item => item.option1 === flavor && item.option2 === count);
    if (!variant?.available) throw new Error('This flavor and quantity are currently unavailable.');
    if (!delivery) throw new Error('Choose a delivery option.');
    const plan = delivery.value || null;
    const allocation = plan ? variant.selling_plan_allocations?.find(item => String(item.selling_plan_id) === String(plan)) : null;
    if (plan && !allocation) throw new Error('This subscription is unavailable for your selection.');
    return {variant, plan, allocation};
  }
  async function submitProduct(form) {
    if (form.dataset.adding) return;
    const button = form.querySelector('[type=submit]');
    const quick = form.hasAttribute('data-cart-quick-add');
    const status = form.querySelector(quick ? '[data-quick-status]' : '[data-product-status]');
    const previousLabel = button?.innerHTML;
    form.dataset.adding = 'true'; if (button) button.disabled = true;
    try {
      const data = new FormData(form); const properties = {};
      for (const [key,value] of data) if (/^properties\[.+\]$/.test(key)) properties[key.slice(11,-1)] = value;
      let id = data.get('id'), plan = data.get('selling_plan');
      if (quick) {const selected = quickSelection(form, await product('flywell')); id = selected.variant.id; plan = selected.plan;}
      else if (form.hasAttribute('data-fp-product')) {const selected = customProductSelection(form, await product(form.dataset.fpProduct)); id = selected.variant.id; plan = selected.plan;}
      await add(id, Number(data.get('quantity')) || 1, plan, properties);
      if (quick) {await renderCart(currentCart); if (status) status.textContent = form.dataset.cartQuickAdd + ' added to your cart.'; document.querySelector('.prototype-cart-page')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});}
      else await drawer();
    } catch(error) {if (status) status.textContent = error.message; else toast(error.message);}
    finally {delete form.dataset.adding; if (button) {button.disabled = false; if (previousLabel) button.innerHTML = previousLabel;} if (quick) updateQuick(form, await product('flywell'));}
  }
  function changeLine(key, quantity) {
    cartRequest = cartRequest.catch(() => {}).then(async () => {
      try {const value = await request('cart/change.js', {id:key, quantity:Math.max(0, Number(quantity) || 0)}); currentCart = value; badge(value); await renderCart(value);}
      catch(error) {toast(error.message); await renderCart();}
    });
    return cartRequest;
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\.js)?(?:\?|$)/.test(form.getAttribute('action') || '')) return;
    if (!form.hasAttribute('data-fp-product') && !form.hasAttribute('data-cart-quick-add')) return;
    event.preventDefault(); event.stopImmediatePropagation(); submitProduct(form).catch(error => toast(error.message));
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('a,button'); if (!button) return;
    if (button.hasAttribute('data-fw-close')) {event.preventDefault(); closeDrawer();}
    if (button.hasAttribute('data-fw-remove')) {event.preventDefault(); changeLine(button.dataset.fwRemove, 0);}
    const href = button.getAttribute('href');
    if (href && hasDiscountLink(href)) return;
    if (button.hasAttribute('data-fw-checkout') || button.hasAttribute('data-checkout') || button.name === 'checkout') {
      event.preventDefault(); event.stopImmediatePropagation();
      discountRequest.catch(() => false).finally(() => {location.href = href || checkoutUrl();});
    }
  }, true);
  document.addEventListener('change', event => {if (event.target.dataset.fwQuantity) changeLine(event.target.dataset.fwQuantity, event.target.value);});
  document.addEventListener('keydown', event => {
    const panel = document.querySelector('.prototype-dialog'); if (!panel) return;
    if (event.key === 'Escape') closeDrawer();
    if (event.key === 'Tab') {const controls = [...panel.querySelectorAll('button,a[href],input,select,summary')].filter(node => !node.disabled && node.getClientRects().length); const first = controls[0], last = controls.at(-1); if (event.shiftKey && document.activeElement === first) {event.preventDefault(); last?.focus();} else if (!event.shiftKey && document.activeElement === last) {event.preventDefault(); first?.focus();}}
  });
  async function init() {
    const isCart = location.pathname.replace(/\/$/, '').endsWith('/cart');
    if (isCart) {await initQuickAdd(); try {await renderCart();} catch(error) {toast('Your cart could not load. Please refresh to try again.');}}
    else cart().catch(() => {});
  }
  window.FlyWellNative = {product, products, cart, add, addBundle, resolveBundle, customProductSelection, drawer, setDiscount, currentDiscount, hasOtherDiscount, money, url};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


